export const formCollectionTypesEnum = Object.freeze({
  worksite_status_declarations: 'worksite_status_declarations',
  tr_meters: 'tr_meters',
  self_supervision_memos: 'self_supervision_memos',
  self_handover_forms: 'self_handover_forms',
  worksite_journals: 'worksite_journals',
  orientation_forms: 'orientation_forms',
  weekly_review_forms: 'weekly_review_forms',
  hot_work_permit_forms: 'hot_work_permit_forms',
  personnel_lift_usage_permits: 'personnel_lift_usage_permits',
  substation_commissioning_inspection_reports:
    'substation_commissioning_inspection_reports',
  measurement_report_attachments: 'measurement_report_attachments',
});

export const formTypesToCollectionTypesEnum = Object.freeze({
  worksite_status_declaration:
    formCollectionTypesEnum.worksite_status_declarations,
  tr_meter: formCollectionTypesEnum.tr_meters,
  self_supervision_memo: formCollectionTypesEnum.self_supervision_memos,
  self_handover_form: formCollectionTypesEnum.self_handover_forms,
  worksite_journal: formCollectionTypesEnum.worksite_journals,
  orientation_form: formCollectionTypesEnum.orientation_forms,
  weekly_review_form: formCollectionTypesEnum.weekly_review_forms,
  hot_work_permit_form: formCollectionTypesEnum.hot_work_permit_forms,
  personnel_lift_usage_permit:
    formCollectionTypesEnum.personnel_lift_usage_permits,
  substation_commissioning_inspection_report:
    formCollectionTypesEnum.substation_commissioning_inspection_reports,
  measurement_report_attachment:
    formCollectionTypesEnum.measurement_report_attachments,
});

export const getFormCollectionTypeByFormType = (formType) =>
  formTypesToCollectionTypesEnum[formType] || null;

export const getFormCollectionTranslationKey = (collectionType) =>
  collectionType ? `forms.${collectionType}` : null;
